import { TFunction } from 'i18next';

import carolinaImg from 'shared/presentation/assets/testimonials/carolina.jpeg';
import kaynaraImg from 'shared/presentation/assets/testimonials/kaynara.jpeg';
import nataliaImg from 'shared/presentation/assets/testimonials/natalia.png';
import samiaImg from 'shared/presentation/assets/testimonials/samia.jpeg';

export const TESTIMONIALS = (t: TFunction<'shared'>) => [
  {
    image: kaynaraImg,
    title: 'Kaynara Paixão',
    text: t(
      'I am very happy with the results I got at Vialaser, they are visible at the first session, I loved it very much And the service is also excellent, they clear all our doubts and are very thoughtfull! I liked it a lot, and recommend it!',
    ),
  },
  {
    image: carolinaImg,
    title: 'Carolina Leal',
    text: t(
      'Initally I was afraid of laser hair removal because I have dark skin, and the fear of wounds and stains was huge When I met Vialaser and they explained me about the techonology used and the care I should take with my skin the fear ended and everything worked out right! My session was quick and painless I left without any burning, stains or discomfort and I was excited for the next sessions and to buy new packages for other areas I highly recommend it!',
    ),
  },
  {
    image: nataliaImg,
    title: 'Natália Pessoa',
    text: t(
      "It was surprising to find there is hair removal for dark skin The service is really good, I was well treated sinced the first session and well informed about sessions' steps",
    ),
  },
  {
    image: samiaImg,
    title: 'Sâmia Rocha',
    text: t(
      "I'm living a dream, that is my hair removal With each session I'm happier and accomplished with the results and the professionals' service Really, Vialaser has the most painless and comfortable method I've ever known, and I recommend it to everyone! 🥰",
    ),
  },
];
